module.exports = __webpack_public_path__ + "static/media/gallery11.c500ecb9.png";